import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import ProductGridItem from '../components/ProductGridItem';

export default class DynamicFeaturedCollection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);

    // Product items
    this.productItems = [];
    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(new ProductGridItem($(productItem)));
    });

    this._updatePrices();
  }

  _updatePrices() {
    this.$el.find('.money').each((index, el) => CurrencyConverter.update(el));
  }

  onSectionUnload() {
    this.productItems.forEach((productItem) => {
      productItem.unload();
    });
  }
}
